import type { Cell, ColumnDef, Row, SortingState } from '@tanstack/react-table';

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@connected/ui/components/table';
import { flexRender, getCoreRowModel, getPaginationRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useState } from 'react';

import {
    EventCalendar,

} from '@/components/event-calendar';
import { cn } from '@/lib/utils';

export type CalendarTableProps<TData, TValue> = {
    columns: ColumnDef<TData, TValue>[];
    className?: string;
    data: TData[];
    pageSize?: number;
    cellProps?: (cell: Cell<TData, TValue>) => React.HTMLAttributes<HTMLTableCellElement> & { ref?: React.RefObject<HTMLTableCellElement | null> };
    rowProps?: (row: Row<TData>) => React.HTMLAttributes<HTMLTableRowElement> & { ref?: React.RefObject<HTMLTableRowElement | null> };
};

export function CalendarTableRoot<TData, TValue>({
    className,
    columns,
    data,
}: CalendarTableProps<TData, TValue>) {
    const [sorting, setSorting] = useState<SortingState>([]);
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting,
        },
        getPaginationRowModel: getPaginationRowModel(),
    });

    return (
        <div className={cn('rounded-2xl border mb-10 overflow-hidden', className)}>
            <Table className={cn('overflow-hidden', className)}>
                <TableHeader className="bg-background-secondary">
                    {table.getHeaderGroups().map(headerGroup => (
                        <TableRow key={headerGroup.id}>
                            {headerGroup.headers.map((header) => {
                                return (
                                    <TableHead key={header.id}>
                                        {header.isPlaceholder
                                            ? null
                                            : flexRender(
                                                    header.column.columnDef
                                                        .header,
                                                    header.getContext(),
                                                )}
                                    </TableHead>
                                );
                            })}
                        </TableRow>
                    ))}
                </TableHeader>
                <TableBody>

                </TableBody>
            </Table>
        </div>
    );
}

type CalendarTableHeaderProps = {
    organizationId: string;
};

export function CalendarTableHeader({
    organizationId,
}: CalendarTableHeaderProps) {
    return (
        <>
            <EventCalendar organizationId={organizationId} />
        </>
    );
};

export const CalendarTable = Object.assign(CalendarTableRoot, {
    Header: CalendarTableHeader,
});
